import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_IOS_MOBILE, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import type { YearAndMonthProductIds } from 'reactApp/modules/products/products.types';

const value: undefined | 'a' | 'b' | 'c' | 'd' | 'e' = getFeature('price-differentiation');

export const isPriceDifferentiation = Boolean(value) && value !== 'a';

export const isAllowedPriceDiffOverquota: boolean = isFeature('price-differentiation-overquota');

export const priceDiffBasicTariffListDesktop: YearAndMonthProductIds = getFeature('price-diff-basic-tariff-list-desktop');
export const priceDiffAdvancedTariffListDesktop: YearAndMonthProductIds = getFeature('price-diff-advanced-tariff-list-desktop');
export const priceDiffFamilyTariffListDesktop: YearAndMonthProductIds = getFeature('price-diff-family-tariff-list-desktop');

export const priceDiffBasicTariffListMobile: YearAndMonthProductIds = getFeature('price-diff-basic-tariff-list-mobile');
export const priceDiffAdvancedTariffListMobile: YearAndMonthProductIds = getFeature('price-diff-advanced-tariff-list-mobile');
export const priceDiffFamilyTariffListMobile: YearAndMonthProductIds = getFeature('price-diff-family-tariff-list-mobile');

const priceDiffTariffsTouch: YearAndMonthProductIds = getFeature('price-diff-tariff-list-touch');
const priceDiffTariffsIOS: YearAndMonthProductIds = getFeature('price-diff-tariff-list-ios');
const priceDiffTariffsAndroid: YearAndMonthProductIds = getFeature('price-diff-tariff-list-android');
const priceDiffTariffsWebview = IS_IOS_MOBILE ? priceDiffTariffsIOS : priceDiffTariffsAndroid;
export const priceDiffTariffsMobile = IS_WEBVIEW ? priceDiffTariffsWebview : priceDiffTariffsTouch;
